"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _toConsumableArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/toConsumableArray");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 1em;\n  > span {\n    display: block;\n    font-size: ", ";\n    color: white;\n    text-align: center;\n    padding: ", ";\n    border: solid 1px white;\n    border-radius: 2px;\n    line-height: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QualitySelector = void 0;

var icons_1 = require("@ant-design/icons");

var web_1 = require("@thesisedu/web");

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var Reset_1 = require("../../Reset");

var styled_1 = require("../styled");

function getLevelFpsLabel(level) {
  var attributes = level.attrs; // Types are wrong.

  return attributes['FRAME-RATE'] === '30' || !attributes['FRAME-RATE'] ? '' : attributes['FRAME-RATE'];
}

function QualitySelector(_ref) {
  var levels = _ref.levels,
      currentLevel = _ref.currentLevel,
      onChange = _ref.onChange,
      compact = _ref.compact;
  var currentLevelObject = currentLevel !== undefined ? levels[currentLevel] : undefined;
  return react_1.default.createElement(antd_1.Dropdown, {
    trigger: ['click'],
    placement: 'topCenter',
    overlay: react_1.default.createElement(antd_1.Menu, {
      selectedKeys: currentLevel !== undefined ? [currentLevel.toString()] : undefined,
      onClick: function onClick(_ref2) {
        var key = _ref2.key;
        return onChange(parseInt(key.toString(), 10));
      }
    }, _toConsumableArray(levels).reverse().map(function (level, index) {
      return react_1.default.createElement(antd_1.Menu.Item, {
        key: (levels.length - 1 - index).toString()
      }, level.height, "p", getLevelFpsLabel(level));
    }))
  }, react_1.default.createElement(antd_1.Tooltip, {
    title: 'Video Quality'
  }, react_1.default.createElement(styled_1.ControlContainer, {
    compact: !!compact,
    padded: true
  }, currentLevelObject ? react_1.default.createElement(Container, null, react_1.default.createElement("span", null, currentLevelObject.height, "p")) : react_1.default.createElement(icons_1.SettingOutlined, null))));
}

exports.QualitySelector = QualitySelector;
var Container = (0, web_1.styled)(Reset_1.Reset.Button)(_templateObject(), function (props) {
  return props.theme['@font-size-xs'];
}, function (props) {
  return props.theme['@size-xxs'];
});